import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="py-16 px-6 md:px-12 bg-ink-900 text-white" data-id="element-108">
      <div className="container mx-auto max-w-5xl" data-id="element-109">
        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-110">
          <div data-id="element-111">
            <div className="text-xl font-medium mb-4 font-currency tracking-wider" data-id="element-112">
              Davood Torabzadeh
            </div>
            <p className="text-ink-300 text-sm font-serif" data-id="element-113">
              Product leader helping teams turn ambiguity into shipped outcomes.
            </p>
          </div>
          <div className="flex justify-start md:justify-end space-x-8" data-id="element-114">
            <a href="mailto:davood@primeroadmap.com" className="text-white hover:text-ink-300 transition-colors" data-id="element-115">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-116">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-117" />
              </svg>
            </a>
            <a href="https://linkedin.com/in/davoodtr" className="text-white hover:text-ink-300 transition-colors" data-id="element-118">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-119">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-120" />
              </svg>
            </a>
            <a href="https://x.com/davoodtr" className="text-white hover:text-ink-300 transition-colors" data-id="element-121">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" data-id="element-122">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" data-id="element-123" />
              </svg>
            </a>
          </div>
        </div>
        <div className="border-t border-ink-800 mt-12 pt-8 text-center" data-id="element-124">
          <p className="text-ink-300 text-sm font-serif" data-id="element-125">
            &copy; {currentYear} Davood Torabzadeh. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}